import { HttpClient } from 'modules/http-client'

export type BadgesStateType = {
  goal: number
  review: number
  feedback: number
  myTeam: number
  teamGoals: number
  teamReview: number
}

const PERSON_NAMESPACE = 'persons'

const api = {
  allBadges: (personId: number) => `${PERSON_NAMESPACE}/${personId}/badges`,
  badges: (personId: number, badgeType: number) => `${api.allBadges(personId)}?badgeTypes=${badgeType}`,
}

export class SignalRService {
  constructor(private httpClient: HttpClient) {}

  initBadges(personId: number, badgeType: number) {
    return this.httpClient
      .get<{ [key: string]: number }>(api.badges(personId, badgeType))
      .then(({ data }) => Number(data[Object.keys(data)[0]])) // @fixme: hacky approach :/ we need value of { something: 10 }
  }

  allBadges(personId: number) {
    return this.httpClient.get<BadgesStateType>(api.allBadges(personId)).then(({ data }) => data)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/signalR.service.ts